import { css } from 'styled-components';

export const breakPoints = config => Object
  .keys(config)
  .reduce((values, key) => {
    values[key] = {
      size: `${config[key] / 16}em`,
      max: (...args) => css`@media (max-width: ${config[key] / 16}em) { ${css(...args)} }`,
      min: (...args) => css`@media (min-width: ${config[key] / 16}em) { ${css(...args)} }`
    };

    return values;
  }, {});

export default breakPoints;
